import { usePathname, useRouter } from 'next/navigation';

import { APP_ROUTES } from '@/routes';
import { useTranslations } from 'next-intl';

const useCartSummary = () => {
	const t = useTranslations();
	const pathName = usePathname();
	const router = useRouter();
	const isCartPage = pathName === APP_ROUTES.PAYMENT.CART;

	const pathNameMap = {
		[APP_ROUTES.PAYMENT.CART]:     t('My Cart'),
		[APP_ROUTES.PAYMENT.CHECKOUT]: t('Checkout'),
	} as Record<string, string>;

	const pageTitle = pathNameMap[pathName] || t('Payment');

	const handleGoToCheckout = () => router.push(APP_ROUTES.PAYMENT.CHECKOUT);

	const cartSummaryDetail = {
		subtotal: 100,
		shipping: 0,
		discount: 50,
		total:    50,
	};

	return {
		cartSummaryDetail,
		pageTitle,
		handleGoToCheckout: isCartPage ? handleGoToCheckout : undefined,
	};
};

export default useCartSummary;